/**
 * Parses a comma-separated accept list (MIME types and/or `.ext` entries), matching the
 * same format used for the native `<input accept>` attribute — call once per `acceptedFormats`
 * value and reuse across a batch of files rather than re-parsing per file.
 */
export function parseAcceptedFormats(acceptedFormats: string): string[] {
  return acceptedFormats
    .split(',')
    .map(entry => entry.trim().toLowerCase())
    .filter(Boolean);
}

/**
 * Checks a File against pre-parsed accept-list entries (see `parseAcceptedFormats`).
 * MIME type is checked in addition to extension since some browsers/OSes don't
 * reliably set `file.type` for every format.
 */
export function isAcceptedFileType(file: File, entries: string[]): boolean {
  if (entries.length === 0) return true;

  const fileType = file.type.toLowerCase();
  const fileName = file.name.toLowerCase();

  return entries.some(entry =>
    entry.startsWith('.') ? fileName.endsWith(entry) : fileType === entry
  );
}
